export default __webpack_public_path__ + "static/media/icon-logout.6afd57d6.svg";